import React, { useState, useRef, useLayoutEffect } from 'react';

interface AhaMenuProps {
  children: React.ReactNode;
  callback?: () => void;
}
const AhaMenu = ({ children, callback }: AhaMenuProps) => {
  const menuRef = useRef<HTMLAhaMenuElement>();
  const [obs, setObs] = useState<MutationObserver>();
  if (!obs) {
    setObs(
      new MutationObserver((mutationList, mutationObserver) => {
        callback?.();
        mutationObserver.disconnect();
      })
    );
  }

  useLayoutEffect(() => {
    if (!menuRef.current) return;
    if (!obs) return;

    obs.observe(menuRef.current, {
      attributes: true,
      subtree: true,
      childList: true,
    });

    return () => obs.disconnect();
  }, [obs]);

  return <aha-menu ref={menuRef}>{children}</aha-menu>;
};

export default AhaMenu;
